import axios from "axios";

export const INTEGRATION_URL_API_URL = __INTEGRATION_URL__;

const $integrationApi = axios.create({
  baseURL: INTEGRATION_URL_API_URL,
});

$integrationApi?.interceptors.request.use((config) => {
  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }
  if (!config.headers.Accept) {
    config.headers.Accept = "application/json";
  }
  return config;
});

export default $integrationApi;
